import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CommonService } from "../../_services/common.service";
import { FlashMessagesService } from "angular2-flash-messages";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CommonProjectDataService } from "../../_services/common-project-data.service";
import { ClientAddressEditComponent } from '../client-address-edit/client-address-edit.component';
import { Router } from "@angular/router";
import { environment } from '../../../environments/environment';
import { SettingService } from "../../_services/setting.service";
import { Auth0Service } from '../../_services/auth0.service';
export interface DialogData {
  user_id: string;
  manageData: any;
  order_id: string;
  amount: number;
  paidAmount: number,
  order_instructions_payment: string;
  order_instruction_title: string;
  paypal_payment_enable: boolean,
  paypal_payment_api_key: string
  turnAroundTimes: Array<any>,
  turn_around_time: string,
  shipping_method: string,
  shipping: Array<any>,
  is_payment_term: string,
  projects: any,
  shippingAddress: Array<any>,
  turnAroundName: string,
  cc_payment_enable: boolean,
  orderType: string,
  is_public_url: string,
  allowPartialPayment: string,
  isPublicQuoteCreation: any,
  public_url_token: any,
  isShippingOption: boolean,
  isLocalPickupOption: boolean,
  cardProcessingFees: Array<any>,
  isConnectQBO: boolean,
  scheduledDate: string
}

declare var grecaptcha: any;
@Component({
  selector: 'app-check-out',
  templateUrl: './check-out.component.html',
  styleUrls: ['./check-out.component.css']
})
export class CheckOutComponent implements OnInit {
  public balanceAmount = 0;
  public id: string;
  public isShowNextButton = true;
  public isShowCheckout = false;
  private tempProjectData: any;
  public showInstruction = true;
  public popHeading: string;
  public deliveryDate: string;
  public shippingAddressId = '';
  private errorMsg = null;
  public activeProjectIndex = 0;
  public min_order_qty = 0;
  public receivableCount: number;
  userDetails: any = {};
  public deliveryMethod = 'select';
  // public deliveryMethod = 'pickup';
  public shipAddress: any;
  public pickupAddressOptions: any;
  public shippingMethodName: string;
  checkOutForm: FormGroup;
  cardData: any = {};
  cardTypes: Array<any> = [
    { value: "0", viewValue: "Use New Card" },
    { value: "1", viewValue: "Old Card" }
  ];
  selectedType = 0;
  address_id = "";
  loading: any = false;
  expiryMonths: Array<any> = [
    { value: "", viewValue: "Month" },
    { value: "1", viewValue: "1" },
    { value: "2", viewValue: "2" },
    { value: "3", viewValue: "3" },
    { value: "4", viewValue: "4" },
    { value: "5", viewValue: "5" },
    { value: "6", viewValue: "6" },
    { value: "7", viewValue: "7" },
    { value: "8", viewValue: "8" },
    { value: "9", viewValue: "9" },
    { value: "10", viewValue: "10" },
    { value: "11", viewValue: "11" },
    { value: "12", viewValue: "12" }
  ];

  expiryYears: Array<any> = [
    { value: "", viewValue: "Year" },
  ];
  public partialPaymentType = 'full';
  public excludeDaysType = 'no';
  //For payment successful
  public paymentSuccess: boolean = false;
  display: any;
  isFormValid: boolean = true;
  shipment: boolean = false;

  myScriptElement: HTMLScriptElement | undefined;
  payments: any;
  appId: any;
  locationId: any;
  card: any;
  recaptchaResult: string = '';
  captchaWidgetId = null;
  cardProcessingFee = 0;
  cardProcessingFeeAmount = 0;

  constructor(private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<CheckOutComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private CommonService: CommonService,
    private _flashMessagesService: FlashMessagesService,
    private CommonProjectDataService: CommonProjectDataService,
    public dialog: MatDialog,
    private router: Router,
    private SettingService: SettingService,
    private auth0Service: Auth0Service
  ) {
    this.checkOutForm = this.formBuilder.group({
      card_type: [0],
      card_no: [null],
      expiry_month: [null],
      expiry_year: [null],
      cvv: [null],
      amount: [null, Validators.required],
      newaccount: [null],
      payment_mode: ['Cash', Validators.required],
      address: [null],
      po_number: [null],
      cheque_number: [null]
    });
    this.CommonProjectDataService.receivableCount.subscribe(recCount => {
      this.receivableCount = recCount
    })
  }

  ngOnInit() {
    this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
    if (this.data.is_public_url == 'Yes') {
      if (this.data.isPublicQuoteCreation) {
        this.id = localStorage.getItem("userID");
      }
      else {
        this.id = localStorage.getItem("shopID");
      }
      if (this.data.cc_payment_enable) {
        this.checkOutForm.get("payment_mode").setValue('Card');
      }
      else {
        if (this.data.paypal_payment_enable) {
          this.checkOutForm.get("payment_mode").setValue('PayPal');
        }
      }
    }
    else {
      this.id = localStorage.getItem("userID");
    }

    if (this.data.projects.type == 'Invoice') {
      this.shippingAddressId = (this.data.projects.shipping_address && this.data.projects.shipping_address.address_id) ? this.data.projects.shipping_address.address_id : '';
      this.balanceAmount = this.data.projects.grand_total_price - this.data.paidAmount;
    }
    else {
      this.shippingAddressId = this.data.projects.address_id ? this.data.projects.address_id : '';
      this.balanceAmount = this.data.projects.grand_total_price;
    }
    this.data.amount = this.balanceAmount;

    this.tempProjectData = JSON.parse(JSON.stringify(this.data.projects.projects_data));
    this.shippingMethodName = this.data.projects.shipping_method;
    
    this.getExpiryYears();
    if (this.data.projects.type == 'Invoice') {
      this.deliveryMethod = this.data.shipping_method == 'local_pickup' ? 'pickup' : 'ship';
      this.data.turn_around_time = this.data.turn_around_time == "" ? this.data.projects.turn_around_time : this.data.turn_around_time;
      this.data.projects.turn_around_time_key =  this.data.turn_around_time;
      this.getCards();
    }
   
    if (this.data.order_id != "") {
      this.checkOutForm.get("amount").setValue(this.numRoundToPlace(this.data.amount, 2));
    }

    //Initially set as default values 
    this.checkOutForm.get("payment_mode").setValue('');

    this.paymentTypeChanged();
    this.cardProcessingFeeAmount = this.data.projects.card_processing_fee ? parseFloat(this.data.projects.card_processing_fee) : 0;
  }

  isFieldValid(field: string) {
    return (
      !this.checkOutForm.get(field).valid &&
      this.checkOutForm.get(field).touched
    );
  }

  selectCardType(selectedCardValue) {
    this.selectedType = selectedCardValue;
  }

  selectAddress(selectedAddress) {
    this.address_id = selectedAddress;
  }

  getCards = function (param = null) {
    this.loading = true;
    let cardOptions = {
      id: this.id,
      user_id: this.data.user_id
    }
    this.CommonService.apiService(
      "POST",
      "get/card",
      cardOptions
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          if (response.data) {
            this.cardData = response.data;
            this.shipAddress = null;
            this.pickupAddressOptions = [];
            if (this.cardData.pickupAddressOptions) {
              this.pickupAddressOptions = this.cardData.pickupAddressOptions;
            }
            if (this.cardData.addresses && this.cardData.addresses.length > 0) {
              if (this.shippingAddressId) {
                const shippingAddressData = this.cardData.addresses.find(x => x.address_id == this.shippingAddressId);

                if (shippingAddressData) {
                  this.address_id = shippingAddressData.address_id;
                } else {
                  this.address_id = this.cardData.addresses.find(x => x.is_billing == 1).address_id;
                }
              } else {
                this.address_id = this.cardData.addresses.find(x => x.is_billing == 1).address_id;
              }
              this.checkOutForm.get('address').setValue(this.address_id);
              this.data.projects.address_id = this.address_id;
              this.shipAddress = {
                address: this.cardData.addresses.find(x => x.is_billing === 1),
                customer: this.cardData.customerDetails ? this.cardData.customerDetails : []
              };
              if (param == "ship") {
                this.selectShippingAddress(this.address_id);
              }
              else{
                this.getPrice();
              }
            }
            if (this.cardData.addresses.length === 0 && this.deliveryMethod == 'ship') {
              this._flashMessagesService.show("Please add address and set it on default", {
                cssClass: "alert-warning",
                timeout: 5000
              });
            }
          }
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }

  //conditional validation function for  change card type
  paymentTypeChanged() {
    const cardTypeControl = this.checkOutForm.get('card_type');
    const cardNoControl = this.checkOutForm.get('card_no');
    const expiryMonthControl = this.checkOutForm.get('expiry_month');
    const expiryYearControl = this.checkOutForm.get('expiry_year');
    const cvvControl = this.checkOutForm.get('cvv');
    const newAccountControl = this.checkOutForm.get('newaccount');
    this.checkOutForm.get('card_type').valueChanges.subscribe(
      (mode: string) => {
        if (mode != '0') {
          cardNoControl.clearValidators();
          expiryMonthControl.clearValidators();
          expiryYearControl.clearValidators();
          cvvControl.clearValidators();
        }
        else {
          cardNoControl.setValidators([Validators.required]);
          expiryMonthControl.setValidators([Validators.required]);
          expiryYearControl.setValidators([Validators.required]);
          cvvControl.setValidators([Validators.required]);
        }

        cardNoControl.updateValueAndValidity();
        expiryMonthControl.updateValueAndValidity();
        expiryYearControl.updateValueAndValidity();
        cvvControl.updateValueAndValidity();

      });
    this.checkOutForm.get('payment_mode').valueChanges.subscribe(
      (mode: string) => {
        if (mode == 'PaymentTerm') {
          this.checkOutForm.get("amount").setValue(0);
        }
        else {
          this.checkOutForm.get("amount").setValue(this.numRoundToPlace(this.data.amount, 2));
        }
        if (mode == 'Cash' || mode == 'Cheque' || mode == 'PayPal' || mode == 'PaymentTerm' || mode == 'PayLater') {
          cardNoControl.clearValidators();
          expiryMonthControl.clearValidators();
          expiryYearControl.clearValidators();
          cvvControl.clearValidators();
        }
        else {
          if (cardTypeControl.value != 0) {
            cardNoControl.clearValidators();
            expiryMonthControl.clearValidators();
            expiryYearControl.clearValidators();
            cvvControl.clearValidators();
          }
          else {
            cardNoControl.setValidators([Validators.required]);
            expiryMonthControl.setValidators([Validators.required]);
            expiryYearControl.setValidators([Validators.required]);
            cvvControl.setValidators([Validators.required]);
          }
        }
        cardNoControl.updateValueAndValidity();
        expiryMonthControl.updateValueAndValidity();
        expiryYearControl.updateValueAndValidity();
        cvvControl.updateValueAndValidity();

      });
  }

  squareUpPaymentClick = async function () {
    var payableAmount = parseFloat(this.checkOutForm.value.amount);

    // Convert all numbers to integers before performing the comparison:
    const postDatatAmt = Math.round(parseFloat(this.checkOutForm.value.amount) * 100);
    const thisDataAmt = Math.round(parseFloat(this.data.amount) * 100);
    const cardProcessingFeeAmt = Math.round(parseFloat(this.cardProcessingFee || 0) * 100);

    if (postDatatAmt > (thisDataAmt + cardProcessingFeeAmt)) {
      this._flashMessagesService.show("Amount is invalid", {
        cssClass: "alert-warning",
        timeout: 5000
      });
      return
    }

    // Get redirect url according to the public quote builder

    let redirectUrl = '';

    if (this.data.isPublicQuoteCreation && this.data.isPublicQuoteCreation == true && this.data.public_url_token) {
      const urlHost = `${window.location.protocol}//${window.location.hostname}`;
      const urlPort = window.location.port ? `:${window.location.port}` : '';
      const urlPath = `/builder/invoice/${this.data.public_url_token}?order=${this.data.order_id}`;
      redirectUrl = urlHost + urlPort + urlPath;
    }
    else {
      redirectUrl = window.location.href + '?order=' + this.data.order_id;
    }

    await this.handlePaymentMethodSubmission(payableAmount, redirectUrl);
  }

  processPayments = function (postData) {
    var obj = this;
    const paymentData = new FormData();

    // Convert all numbers to integers before performing the comparison:
    const postDatatAmt = Math.round(parseFloat(postData.amount) * 100);
    const thisDataAmt = Math.round(parseFloat(this.data.amount) * 100);
    const cardProcessingFeeAmt = Math.round(parseFloat(this.cardProcessingFee || 0) * 100);

    if (postDatatAmt > (thisDataAmt + cardProcessingFeeAmt)) {
      this._flashMessagesService.show("Amount is invalid", {
        cssClass: "alert-warning",
        timeout: 5000
      });
      return
    }

    if (this.data.is_public_url == 'Yes') {
      paymentData.append('id', this.data.user_id);
      paymentData.append('is_public_url', this.data.is_public_url);
    }
    else {
      paymentData.append('id', localStorage.getItem("userID"));
    }

    paymentData.append('order_id', this.data.order_id);
    paymentData.append('payment_type', postData.payment_mode);
    paymentData.append('amount', postData.amount);
    paymentData.append('address_id', postData.address);
    paymentData.append('po_number', postData.po_number);
    paymentData.append('cardProcessingFee', this.cardProcessingFee);

    if (postData.payment_mode == "Cheque") {
      paymentData.append('cheque_number', postData.cheque_number);
    }
    if (postData.payment_mode == "Card") {
      paymentData.append('card_id', postData.card_type);
      if (postData.card_type == "0") {
        paymentData.append('card_number', postData.card_no);
        paymentData.append('card_expiry_month', postData.expiry_month);
        paymentData.append('card_expiry_year', postData.expiry_year);
        paymentData.append('card_cvv', postData.cvv);
        paymentData.append('is_card_save', postData.newaccount == true ? '1' : '0');
        
        if (this.data.cc_payment_api == 'quickbooks') {
          paymentData.append('recaptcha', this.recaptchaResult);
        }
      }
    }
    else {
      console.log("Payment Mode:", postData.payment_mode);
    }

    const fullOneTimeDiscount = (this.data.projects.grand_total_price == 0 && this.data.projects.one_time_discounted_amt > 0) ? 'Yes' : 'No';
    paymentData.append('fullOneTimeDiscount', fullOneTimeDiscount);

    this.loading = true;

    this.CommonService.apiService(
      "POST",
      "payment",
      paymentData
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          if (postData.payment_mode == "PaymentTerm") {
            this.CommonProjectDataService.receivableCount.next(this.receivableCount + 1);
            this.userDetails.receivable_count = this.receivableCount;
            localStorage.setItem("userDetails", JSON.stringify(this.userDetails));
          }
          if (postData.payment_mode != 'PayLater' && this.data.isConnectQBO) {
            this.syncInvoicePayment(this.data.order_id, postData.amount, postData.payment_mode);
          }
          if (this.data.is_public_url === "Yes") {
            //Show Thankyou for 5 seconds and close pop-up
            this.showThankyou();
          }
          else{
            if(response.data) {
              localStorage.setItem("cardPaymentData", JSON.stringify(response.data));
            }
            this.dialogRef.close("success");
          }
          this.loading = false;
        } else {
          this.loading = false;
        }
        window.scrollTo(0, 0);
      },
      (err: any) => {
        obj.loading = false;
        obj.notificationMessage(err.error.message);
        
        if (err.error.recaptcha) {
          this.resetReCaptcha();
        }
      }
    );
  };

  getExpiryYears() {
    var date = new Date();
    for (let currentYear = 0; currentYear < 10; currentYear++) {
      this.expiryYears.push(
        {
          value: date.getFullYear() + currentYear,
          viewValue: date.getFullYear() + currentYear
        });

    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  showPaymentProcess() {
    this.showInstruction = this.showInstruction == false ? true : false;
    this.popHeading = this.showInstruction == true ? this.data.order_instruction_title : "Checkout";
  }

  togglePayment(status) {
    if (status == true) {
      if (this.data.is_public_url === "Yes") {
        this.showThankyou();
      }
      else{
        this.dialogRef.close("success");
      }
    }
  }

  selectTrunAround(selectedTurnAround) {
    this.checkOutForm.controls.payment_mode.setValue('');
    if (selectedTurnAround != "") {
      this.data.turn_around_time = selectedTurnAround;
      this.data.projects.turn_around_time_key = selectedTurnAround;
      //call get price api
      this.getPrice();
    }
    else {
      this._flashMessagesService.show("Please Select Turn Around", {
        cssClass: "alert-danger",
        timeout: 5000
      });
      this.data.turn_around_time = "";
      this.data.projects.turn_around_time_key = "";
    }
    this.ValidationForm();
  }

  selectShippingMethod(selectedShippingMethod, getPrice = true) {
    this.checkOutForm.controls.payment_mode.setValue('');
    if (selectedShippingMethod != "") {
      this.data.shipping_method = selectedShippingMethod;
      //this.shippingMethodName = this.data.shipping.find(x => x.key_value === selectedShippingMethod).name.split('(').shift();
      let shippingMethod = this.data.shipping.find(x => x.key_value === selectedShippingMethod);
      if(shippingMethod){
        this.shippingMethodName = shippingMethod.name.split('(').shift();
      }
      this.data.projects.shipping_method_key = this.data.shipping_method;
      //call get price api
      if (getPrice == true) {
        this.getPrice();
      }
    }
    else {
      this._flashMessagesService.show("Please Select Shipping Method", {
        cssClass: "alert-danger",
        timeout: 5000
      });
      this.data.shipping_method = "";
      this.data.projects.shipping_method_key = this.data.shipping_method;
    }
  }

  selectDeliveryMethod(selectedDeliveryMethod) {
    this.checkOutForm.controls.payment_mode.setValue('');
    this.deliveryMethod = selectedDeliveryMethod;
    this.shipment = false;
    if (this.deliveryMethod == 'select') {
      this.ResetPopupData();
    }
    else if (this.deliveryMethod == 'ship') {
      this.getCards(this.deliveryMethod);
      this.shipment = true;
    }
    else {
      this.data.shipping_method = 'local_pickup';
      this.data.projects.shipping_method_key = this.data.shipping_method;
      let shippingMethod = this.data.shipping.find(x => x.key_value === this.data.shipping_method);
      if(shippingMethod){
        this.shippingMethodName = shippingMethod.name.split('(').shift();
      }
      this.getCards(this.deliveryMethod);
    }
    this.ValidationForm();
  }

  selectShippingAddress(selectedAddress) {
    if (selectedAddress != "") {
      this.shippingAddressId = selectedAddress;
      this.data.projects.address_id = this.shippingAddressId;
      //call get price api
      this.data.shipping = [];
      this.getPrice();
    }
    else {
      this._flashMessagesService.show("Please Select Address", {
        cssClass: "alert-danger",
        timeout: 5000
      });
      this.data.projects.address_id = "";
    }
  }

  getPrice = function () {
    if (!(this.data.projects.type == 'Invoice' && this.data.projects.isInvoiceEditable === 0)) {
      this.loading = true;
      this.isShowCheckout = false;
      let projects = this.tempProjectData;
      let user_id = this.data.projects.user_id;
      let finalArr = []
      projects.forEach((pvalue, pkey) => {
        let activeLoc = pvalue.active_location_arr;
        let projectTitle = (pvalue.projectTitle) ? pvalue.projectTitle : "";
        let isCheckedProjectTab = (pvalue.isCheckedProjectTab) ? pvalue.isCheckedProjectTab : "";
        let totalPriceCalculation = (pvalue.totalPriceCalculation) ? pvalue.totalPriceCalculation : false;
        if (pvalue.products && pvalue.products.length > 0) {
          pvalue.products.forEach((product, key) => {
            if (finalArr[pkey] && finalArr[pkey].products) {
              Object.assign(finalArr[pkey].products, { [product.product_id]: {} });
              Object.assign(finalArr[pkey].products_matrix, { [product.product_id]: {} });
            }
            else {
              finalArr[pkey] = {
                'products': { [product.product_id]: {} },
                'products_matrix': { [product.product_id]: {} },
                'printPositionSetting': pvalue.printPositionSetting,
                'finishingDetails': (pvalue.finishing_type_id) ? pvalue.finishing_type_id : [],
                'inkDetail': (pvalue.ink_Details && pvalue.ink_Details.ink_type_id) ? pvalue.ink_Details.ink_type_id : null,
                'section_items': pvalue.section_items,
                'isCheckedProjectTab': isCheckedProjectTab,
                'projectTitle': projectTitle,
                'productsMatrixData': pvalue.products,
                'totalPriceCalculation': totalPriceCalculation
              };
            }
            finalArr[pkey].ownGarmentsWeight = pvalue.ownGarmentsWeight;

            // set inkColors under printPositionSetting
            if (activeLoc && activeLoc.length > 0) {
              activeLoc.forEach((lval, lkey) => {

                if (pvalue.inkColors && pvalue.inkColors[lval.emblocation_id]) {
                  let tmpInkColor = (pvalue.inkColors[lval.emblocation_id]) ? pvalue.inkColors[lval.emblocation_id] : [];
                  if (pvalue.printPositionSetting[lval.emblocation_id]) {
                    pvalue.printPositionSetting[lval.emblocation_id]['inkColors'] = tmpInkColor;
                  }
                  else {
                    pvalue.printPositionSetting[lval.emblocation_id] = { ['inkColors']: tmpInkColor };
                  }
                }
                // set printAddonSetting under printPositionSetting
                if (pvalue.printAddonSetting) {
                  if (pvalue.printPositionSetting[lval.emblocation_id]) {
                    pvalue.printPositionSetting[lval.emblocation_id]['printAddonSetting'] = (pvalue.printAddonSetting[lval.emblocation_id]) ? pvalue.printAddonSetting[lval.emblocation_id] : {};
                  }
                }

                // set inkChangeData under printPositionSetting
                if (pvalue.inkChangeData) {
                  if (pvalue.printPositionSetting[lval.emblocation_id]) {

                    if (pvalue.inkChangeData[lval.emblocation_id]) {
                      pvalue.printPositionSetting[lval.emblocation_id]['inkChangeData'] = this.processInkChangeData(pvalue.inkChangeData[lval.emblocation_id]);
                    }
                    else {
                      pvalue.printPositionSetting[lval.emblocation_id]['inkChangeData'] = [];
                    }
                  }
                }
                if (pvalue.artwork) {
                  let artTmp = Object.keys(pvalue.artwork).length;
                  if (pvalue.artwork && artTmp > 0) {
                  }
                }
                finalArr[pkey].printPositionSetting = pvalue.printPositionSetting;
                product.matrix.forEach(function (mval, mkey) {
                  if (finalArr[pkey].products[product.product_id]) {
                    Object.assign(finalArr[pkey].products[product.product_id], { [mval.color.color_id]: {}, type: product.productDetail.type });
                    Object.assign(finalArr[pkey].products_matrix[product.product_id], { [mval.color.color_id]: mval.matrix_id });
                  }
                  else {
                    finalArr[pkey].products[product.product_id] = { [mval.color.color_id]: {}, type: product.productDetail.type };
                    finalArr[pkey].products_matrix[product.product_id] = { [mval.color.color_id]: mval.matrix_id };
                  }
                  mval.quantity.forEach(function (qval, qkey) {

                    if (qval && qval > 0) {
                      if (finalArr[pkey].products[product.product_id][mval.color.color_id]) {
                        Object.assign(finalArr[pkey].products[product.product_id][mval.color.color_id], { [mval.size[qkey].size_id]: qval });
                      }
                      else {
                        finalArr[pkey].products[product.product_id][mval.color.color_id] = { [mval.size[qkey].size_id]: qval };
                      }
                    }
                  });
                });
              });
            } else {
              // Assign Product details
              product.matrix.forEach(function (mval, mkey) {
                if (finalArr[pkey].products[product.product_id]) {
                  Object.assign(finalArr[pkey].products[product.product_id], { [mval.color.color_id]: {}, type: product.productDetail.type });
                  Object.assign(finalArr[pkey].products_matrix[product.product_id], { [mval.color.color_id]: mval.matrix_id });
                }
                else {
                  finalArr[pkey].products[product.product_id] = { [mval.color.color_id]: {}, type: product.productDetail.type };
                  finalArr[pkey].products_matrix[product.product_id] = { [mval.color.color_id]: mval.matrix_id };
                }
                mval.quantity.forEach(function (qval, qkey) {
                  if (qval && qval > 0) {
                    if (finalArr[pkey].products[product.product_id][mval.color.color_id]) {
                      Object.assign(finalArr[pkey].products[product.product_id][mval.color.color_id], { [mval.size[qkey].size_id]: qval });
                    }
                    else {
                      finalArr[pkey].products[product.product_id][mval.color.color_id] = { [mval.size[qkey].size_id]: qval };
                    }
                  }
                });
              });
            }
          });
        }
        else {
          finalArr[pkey] = {
            'section_items': pvalue.section_items
          }
        }

      });

      let otherData = {
        user_id: this.data.projects.user_id ? this.data.projects.user_id : '',
        address_id: this.data.projects.address_id ? this.data.projects.address_id : '',
        turn_around_time: this.data.projects.turn_around_time_key ? this.data.projects.turn_around_time_key : 0,
        shipping_method: this.data.projects.shipping_method_key ? this.data.projects.shipping_method_key : "local_pickup",
      }
      let quoteOpt = {
        id: this.id,
        projects_data: finalArr,
        user_id: otherData.user_id,
        address_id: otherData.address_id ? this.data.projects.address_id : '',
        turn_around_time: otherData.turn_around_time,
        shipping_method: otherData.shipping_method,
        one_time_discount_type: this.data.projects.one_time_discount_type ? this.data.projects.one_time_discount_type : '',
        one_time_discount: this.data.projects.one_time_discount ? this.data.projects.one_time_discount : 0
      };

      this.CommonService.apiService(
        "POST",
        "v3/order/get_prices",
        quoteOpt
      ).subscribe(
        (response: any) => {
          if (response.status === true) {
            // console.log("response-", response);
            this.data.projects.delivery_date = response.data.delivery_date;
            this.data.projects.delivery_days = response.data.delivery_days;
            this.data.projects.discount = response.data.discount;
            this.data.projects.discount_percentage = response.data.discount_percentage;
            this.data.projects.grand_total_price = response.data.grand_total_price;
            this.data.projects.shipping_price = response.data.shipping_price;
            this.data.projects.tax = response.data.tax;
            this.data.projects.tax_percentage = response.data.tax_percentage;
            this.data.projects.total_price = response.data.total_price;
            this.data.projects.total_printing_price = response.data.total_printing_price;
            this.data.projects.total_products_price = response.data.total_products_price;
            this.data.projects.total_quantity = response.data.total_quantity;
            this.data.projects.total_weight = response.data.total_weight;
            this.data.projects.turn_around_time_price = response.data.turn_around_time_price;
            this.data.projects.total_projects = response.data.total_projects;
            this.data.projects.total_custom_items_price = response.data.total_custom_items_price;
            if (this.data.paidAmount > 0) {
              this.balanceAmount = response.data.grand_total_price - this.data.paidAmount;
            } else {
              this.balanceAmount = response.data.grand_total_price;
            }
            this.data.amount = this.balanceAmount;
            this.checkOutForm.get("amount").setValue(this.numRoundToPlace((this.data.amount), 2));

            this.data.projects.one_time_discount = response.data.one_time_discount;
            this.data.projects.one_time_discount_type = response.data.one_time_discount_type;
            this.data.projects.one_time_discounted_amt = response.data.one_time_discounted_amt;
            for (let i = 0; i < this.data.projects.projects_data.length; i++) {
              // set  printing price  per project
              this.data.projects.projects_data[i].total_printing_price = response.data.projects[i].total_printing_price;
              this.data.projects.projects_data[i].priceMarkupProduct = response.data.projects[i].priceMarkupProduct;
            }

            this.data.grandTotalPrice = response.data.grand_total_price;
            this.CommonProjectDataService.storeTotalPrice(response.data.grand_total_price);
            if (this.data.projects.order_id) {
              this.CommonProjectDataService.storeDeliveryDate(response.data.delivery_date);
              this.CommonProjectDataService.storeOrderId(this.data.projects.order_id);
              this.CommonProjectDataService.storeClientName(this.data.projects.user_username);
            }
            if (response.data.addresses.length > 0) {
              this.data.shippingAddress = response.data.addresses;
            }
            if (response.data.turn_around_times.length > 0) {
              this.data.turnAroundTimes = response.data.turn_around_times;
              this.data.turnAroundName = this.data.turnAroundTimes[this.data.projects.turn_around_time_key];
            }
            this.CommonProjectDataService.store(this.data.projects);
            this.data.shipping = [];
            Object.entries(response.data.shipping_methods).forEach(
              ([skey, value]) => {
                this.data.shipping.push(
                  {
                    key_value: skey,
                    name: value
                  });
              });
            let getPriceStatus = false;
            if (this.data.shipping.length > 0) {
              if (this.deliveryMethod === 'ship' || (!this.data.shipping_method || this.data.shipping_method == '' || this.data.shipping_method == 'local_pickup')) {
                if (this.data.shipping.find(item => item.key_value !== 'local_pickup') && this.data.shipping.find(item => item.key_value !== 'local_pickup').hasOwnProperty("key_value")) {
                  // this.data.shipping_method = this.data.shipping.find(item => item.key_value !== 'local_pickup').key_value;
                  this.data.shipping_method = otherData.shipping_method;
                  getPriceStatus = true;
                }
                else {
                  this.data.shipping_method = this.data.shipping[0].key_value;
                }
              }
              else {
                this.data.shipping_method = this.data.shipping[0].key_value;
              }
              // this.selectShippingMethod(this.data.shipping_method, getPriceStatus);
            }
            this.loading = false;
          }
        },
        err => {
          this.loading = false;
          console.log("error msg", err.error.message);
        }
      );
    }
  }

  processInkChangeData(inkData) {
    let tmpArr = [];
    inkData.updData.forEach((val, key) => {
      tmpArr[key] = { 'inkColors': [] };
    });

    Object.values(inkData.colorChange).forEach((val, key) => {
      Object.entries(val).forEach(
        ([pkey, value]) => {
          if (tmpArr[key].inkColors) {
            tmpArr[key].inkColors.push(val[pkey].upd.ink_id);
          }
          else {
            tmpArr[key] = { inkColors: [val[pkey].upd.ink_id] };
          }
        }

      );

    });
    return tmpArr;

  }

  validateShippingDetail() {

    if (this.data.turn_around_time == '' || this.shippingAddressId == '' || this.data.shipping_method == '') {
      this.isShowNextButton = true;

    }
    else {
      this.isShowNextButton = false;
    }

  }

  saveQuoteData = function () {
    if (this.data.projects.turn_around_time == "") {
      this._flashMessagesService.show("The turn around time field is required ", {
        cssClass: "alert-danger",
        timeout: 5000
      });
      return
    }
    if (this.data.projects.shipping_method == "") {
      this._flashMessagesService.show("The shipping method field is required ", {
        cssClass: "alert-danger",
        timeout: 5000
      });
      return
    }
    if (this.data.projects.type == 'Invoice' && this.balanceAmount <= 0) {
      this._flashMessagesService.show("Balance amount must be greater than 0 for proceed payment process ", {
        cssClass: "alert-danger",
        timeout: 5000
      });
      return
    }
    let quoteData = {
      'id': this.id,
      'user_id': this.data.user_id ? this.data.user_id : '',
      'order_id': this.data.order_id ? this.data.order_id : '', //this.type == "Duplicate" ? this.duplicateQuoteId : this.id,
      'projects_data': this.data.projects.projects_data,
      'total_projects': this.data.projects.total_projects,
      'total_quantity': this.data.projects.total_quantity,
      'total_weight': this.data.projects.total_weight,
      'total_products_price': this.data.projects.total_products_price,
      'total_printing_price': this.data.projects.total_printing_price,
      'total_price': this.data.projects.total_price,
      'total_custom_items_price': this.data.projects.total_custom_items_price,
      'turn_around_time_price': this.data.projects.turn_around_time_price,
      'shipping_price': this.data.projects.shipping_price,
      'discount': this.data.projects.discount,
      'discount_percentage': this.data.projects.discount_percentage,
      'tax': this.data.projects.tax,
      'tax_percentage': this.data.projects.tax_percentage,
      'grand_total_price': this.data.projects.grand_total_price,
      'delivery_days': this.data.projects.delivery_days,
      'shipping_method': this.data.projects.shipping_method_key ? this.data.projects.shipping_method_key : "local_pickup",
      'turn_around_time': this.data.projects.turn_around_time_key ? this.data.projects.turn_around_time_key : 0,
      'shipping_zip': this.data.projects.shipping_zip ? this.data.projects.shipping_zip : '',
      'address_id': this.shippingAddressId ? this.shippingAddressId : '',
      'guest_email': this.data.projects.guest_email ? this.data.projects.guest_email : '',
      'one_time_discount_type': this.data.projects.one_time_discount_type,
      'one_time_discount': this.data.projects.one_time_discount,
      'one_time_discounted_amt': this.data.projects.one_time_discounted_amt,
      'order_title': this.data.projects.order_title ? this.data.projects.order_title : '',
      'scheduled_date': this.data.scheduledDate
    };
    this.loading = true;

    this.CommonService.apiService(
      "POST",
      "order/save",
      quoteData
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          this.data.projects.shipping_zip = "";
          this.data.projects.order_id = response.data.order_id;
          this.data.projects.token = response.data.token;
          if (this.data.order_id != "") {
            if (this.data.projects.type == 'Invoice') {
              let amount = Number(this.data.projects.grand_total_price) - Number(this.data.paidAmount);
              this.data.amount = this.numRoundToPlace(amount, 2);
            }
            else {
              this.data.amount = this.numRoundToPlace(this.data.projects.grand_total_price, 2);
            }
            let amountPayable = this.data.amount;
            
            if (this.data.is_public_url=='Yes' && this.data.orderType == 'Quote' && this.data.allowPartialPayment=='1' && this.checkOutForm.controls.payment_mode.value!='PaymentTerm') {
              if (this.partialPaymentType == 'half') {
                amountPayable = this.numRoundToPlace((this.data.amount / 2), 2);
              }
            }

            // Calculate the card processing fee if applicable
            this.cardProcessingFee = 0;
            const paymentMode = this.checkOutForm.controls.payment_mode.value;
            const providerName = paymentMode === 'Card' ? this.data['cc_payment_api'] : paymentMode === 'PayPal' ? 'paypal' : '';
            if (providerName) {
              const provider = this.data.cardProcessingFees.find(p => p.provider === providerName);
              if (provider && provider.isChargeFee && provider.percentage) {
                this.cardProcessingFee = (parseFloat(amountPayable) * parseFloat(provider.percentage)) /100;
              }
            }

            amountPayable = parseFloat(amountPayable) + this.cardProcessingFee;
            this.checkOutForm.get("amount").setValue(this.numRoundToPlace(amountPayable, 2));
          }
          this.isShowCheckout = true;

          this._flashMessagesService.show(response.message, {
            cssClass: "alert-success",
            timeout: 1000
          });

        }
        window.scrollTo(0, 0);
      },
      err => {
        this.loading = false;
        this.isShowCheckout = false;
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-danger",
          timeout: 5000
        });
      }
    );


  };

  // Check Project Data functinality

  validateProjectData() {
    this.errorMsg = '';
    let isvalidateData = false;
    let projectName = '';
    for (let i = 0; i < this.data.projects.projects_data.length; i++) {
      this.activeProjectIndex = i;
      projectName = 'Project' + i
      isvalidateData = this.checkProductInk();
      let isProductExist = JSON.parse(JSON.stringify(isvalidateData));
      if (isvalidateData) {
        isvalidateData = this.checkOrderQuantity();
        if (isvalidateData) {
          isvalidateData = this.checkPrintSpec();
        }
      }
      isvalidateData = this.validateSectionData(isProductExist);
      if (!isvalidateData && this.errorMsg) {
        this._flashMessagesService.show(projectName + ' : ' + this.errorMsg, {
          cssClass: "alert-danger",
          timeout: 5000
        });
        return isvalidateData;
      }
    }
    if (this.errorMsg) {
      this._flashMessagesService.show(projectName + ' : ' + this.errorMsg, {
        cssClass: "alert-danger",
        timeout: 5000
      });
    }
    else {
      this.saveQuoteData();
    }
    return isvalidateData
  }

  checkProductInk() {
    if (this.data.projects.projects_data[this.activeProjectIndex].products && this.data.projects.projects_data[this.activeProjectIndex].products.length > 0) {
      let totalProjectQuantity = this.data.projects.projects_data[this.activeProjectIndex].totalProjectQuantity;
      if (totalProjectQuantity <= 0) {
        this.errorMsg = "Please enter product quantity";
        return false;
      }
      else {
        return true
      }
    }
    else {
      return false;
    }
  }

  checkOrderQuantity() {
    let isQuantityValidated = true;
    this.min_order_qty = this.CommonProjectDataService.getMinOrderQty();
    let totalProjectQuantity = this.data.projects.projects_data[this.activeProjectIndex].totalProjectQuantity;
    let x = 0;
    if (totalProjectQuantity > 0) {
      this.data.projects.projects_data[this.activeProjectIndex].products.forEach((mvalue, mkey) => {

        if (isQuantityValidated) {
          let isLessOrderLimit = this.data.projects.projects_data[this.activeProjectIndex]['products'][mkey].productDetail.less_order_limit;
          var tmp_total_qty = 0;
          let enteredquantity = 0;
          let productDetail = this.data.projects.projects_data[this.activeProjectIndex]['products'][mkey].productDetail;
          mvalue.matrix.forEach((svalue, skey) => {
            if (isQuantityValidated) {
              svalue.size.forEach((psize, qkey) => {
                if (isQuantityValidated) {
                  if (productDetail.title != 'own-garment') {
                    let sizeStock = productDetail.options[svalue.color.color_id][psize.size_id] ? productDetail.options[svalue.color.color_id][psize.size_id]['quantity'] : 0;
                    enteredquantity = svalue.quantity[qkey] ? svalue.quantity[qkey] : 0;

                    if (productDetail.type != 'custom') {
                      isQuantityValidated = true;
                    }
                    else {
                      if (productDetail.type == 'custom' && (sizeStock == '' || sizeStock == 0 || sizeStock == null) && enteredquantity >= 0) {
                        isQuantityValidated = true;
                      }
                      else {
                        if (enteredquantity > 0 && enteredquantity > sizeStock) {
                          this.errorMsg = "Please enter valid Quantity";
                          isQuantityValidated = false;
                        }
                        else {
                          isQuantityValidated = true;
                        }
                      }
                    }

                  }
                  else {
                    if (enteredquantity > 0) {
                      this.errorMsg = "Please enter valid Quantity";
                      isQuantityValidated = false;
                    }
                    else {
                      isQuantityValidated = true;
                    }
                  }

                }
              }
              )

            }

          });

          if (isLessOrderLimit == 1 && isQuantityValidated) {
            if (totalProjectQuantity <= 0) {
              this.errorMsg = "Please enter Quantity";
              isQuantityValidated = false;
              return isQuantityValidated;
            }
          }
          if (isLessOrderLimit == 0 && isQuantityValidated) {
            if (totalProjectQuantity < this.min_order_qty) {
              this.errorMsg = "Total Quantity must be greater than " + this.min_order_qty;
              isQuantityValidated = false;
              return isQuantityValidated;
            }
            else {
              isQuantityValidated = true;
            }
          }
        }
      });
      if (isQuantityValidated) {
        this.handleQuantity(isQuantityValidated);
      }
    }
    else {
      isQuantityValidated = true;
      if (this.data.projects.projects_data[this.activeProjectIndex].products && this.data.projects.projects_data[this.activeProjectIndex].selectedProductColors) {
        delete this.data.projects.projects_data[this.activeProjectIndex].products;
        delete this.data.projects.projects_data[this.activeProjectIndex].selectedProductColors;
      }
    }
    return isQuantityValidated;
  }

  checkPrintSpec() {
    let isPrintSpec = true;
    let activeLocationArr = this.data.projects.projects_data[this.activeProjectIndex].active_location_arr;
    let projectData = this.data.projects.projects_data[this.activeProjectIndex];

    if (activeLocationArr && activeLocationArr.length > 0) {

      activeLocationArr.forEach((plkey) => {
        if (isPrintSpec) {
          if ((projectData.printPositionSetting && projectData.printPositionSetting[plkey.emblocation_id])
            && (projectData.printPositionSetting[plkey.emblocation_id].printWidth != ''
              && projectData.printPositionSetting[plkey.emblocation_id].printPosition.name != '')) {
            if (projectData.printPositionSetting[plkey.emblocation_id].printType != 'per_color') {
              if (projectData.printPositionSetting[plkey.emblocation_id].printHeight != '') {
                isPrintSpec = true;
              }
              else {
                this.errorMsg = "Please Select print measurements detail";
                isPrintSpec = false;
              }

            }
            else {
              isPrintSpec = true;
            }
            if (projectData.printPositionSetting[plkey.emblocation_id].printType != 'per_item') {
              // if (projectData.printPositionSetting[plkey.emblocation_id].printDistance != '') {
              //   isPrintSpec = true;
              // }
              // else {
              //   this.errorMsg = "Please Select print measurements detail";
              //   isPrintSpec = false;
              // }
              isPrintSpec = true;
            }
            else {
              isPrintSpec = true;
            }

          }
          else {
            this.errorMsg = "Please Select print measurements detail";
            isPrintSpec = false;

          }
        }
        if (isPrintSpec) {
          if (((projectData.inkColorObj && projectData.inkColorObj[plkey.emblocation_id] && projectData.inkColorObj[plkey.emblocation_id].length > 0)
            || (projectData.printAddonInputSettingObj && projectData.printAddonInputSettingObj[plkey.emblocation_id]
              && Object.keys(projectData.printAddonInputSettingObj[plkey.emblocation_id]).length > 0))) {
            isPrintSpec = true;
          }
          else {
            this.errorMsg = "Please select print spec ink color";
            isPrintSpec = false;
          }
        }

      }
      )
      if (isPrintSpec) {
        this.checkInkType();
      }
    }

    return isPrintSpec;
  }

  checkInkType() {
    if (this.data.projects.projects_data[this.activeProjectIndex]['ink_Details'] && this.data.projects.projects_data[this.activeProjectIndex]['ink_Details'].ink_type_id && this.data.projects.projects_data[this.activeProjectIndex]['ink_Details'].ink_name) {
      return true;
    }
    else {
      this.errorMsg = "Please Select Ink type";
      return false;
    }

  }

  handleQuantity(isQuantityValidated) {
    //default select color when color is not selected
    if (isQuantityValidated && this.data.projects.projects_data[this.activeProjectIndex] && this.data.projects.projects_data[this.activeProjectIndex].products.length > 0) {
      //remove products having 0 quantity
      let tempProject = JSON.parse(JSON.stringify(this.data.projects));

      tempProject.projects_data.forEach((pvalue, pkey) => {
        if (pvalue.products) {
          pvalue.products.forEach((mvalue, mkey) => {
            mvalue.matrix.forEach((svalue, skey) => {
              if (this.totalQuantity(svalue.quantity) == 0) {
                delete tempProject.projects_data[pkey]['products'][mkey].matrix[skey];
              }
            })
            mvalue.matrix = mvalue.matrix.filter(function (el) {
              return el != null;
            });

            if (mvalue.matrix.length == 0) {
              tempProject.projects_data[pkey]['products'].splice(mkey, 1);
            }
          })
        }
      })
      this.data.projects = tempProject;
      this.CommonProjectDataService.store(this.data.projects);
    }


  }
  // end

  validateSectionData(isProductExist) {
    let isSectionItemValidate = false;
    let sectionItems = this.data.projects.projects_data[this.activeProjectIndex].section_items;
    if (sectionItems.length == 1 && sectionItems[0].custom_items.length == 1 && this.data.projects.projects_data.length >= 1) {
      let customeItem = sectionItems[0].custom_items[0];
      if (customeItem.item == '' && customeItem.price == 0 && customeItem.quantity == 0 && isProductExist) {
        this.data.projects.projects_data[this.activeProjectIndex].section_items.splice(0);
        isSectionItemValidate = true;
      }
      isSectionItemValidate = true;
    }
    else {
      sectionItems.forEach((svalue, skey) => {
        svalue.custom_items.forEach((cvalue, ckey) => {
          if (cvalue.item == '' && cvalue.price == 0 && cvalue.quantity == 0) {
            isSectionItemValidate = false;
            this.errorMsg = "Custom Line item can not be blank and price and quantity must be greater than 0";
          }
          else {
            isSectionItemValidate = true;
          }
        })
      })
    }

    return isSectionItemValidate;
  }

  totalQuantity = function (rowArr) {
    if (Object.keys(rowArr).length > 0) {
      return rowArr.reduce(function (a, b) {
        return a + b;
      }, 0);
    }
    else {
      return 0;
    }
  }

  convertToNumber(value) {
    return Number(value);
  }

  numRoundToPlace(num, dec) {

    if ((typeof num !== 'number') || (typeof dec !== 'number'))
      return num;

    var num_sign = num >= 0 ? 1 : -1;

    return (Math.round((num * Math.pow(10, dec)) + (num_sign * 0.0001)) / Math.pow(10, dec)).toFixed(dec);
  }

  paymentTypeChange(event) {

    // Calculate the card processing fee if applicable
    this.cardProcessingFee = 0;
    const paymentMode = this.checkOutForm.controls.payment_mode.value;
    const providerName = paymentMode === 'Card' ? this.data['cc_payment_api'] : paymentMode === 'PayPal' ? 'paypal' : '';
    if (providerName) {
      const provider = this.data.cardProcessingFees.find(p => p.provider === providerName);
      if (provider && provider.isChargeFee && provider.percentage) {
        this.cardProcessingFee = (parseFloat(this.data.amount.toString()) * parseFloat(provider.percentage)) /100;
      }
    }
    
    const payAmount = parseFloat(this.data.amount.toString()) + parseFloat(this.cardProcessingFee.toString());

    if (event.value === 'half') {
      
      this.checkOutForm.get("amount").setValue(this.numRoundToPlace((payAmount / 2), 2));
      this.cardProcessingFee = this.cardProcessingFee / 2;
    }
    else {
      this.checkOutForm.get("amount").setValue(this.numRoundToPlace(payAmount, 2));
    }
  }

  changePaymentMethod(event) {
    if (event.value === 'Card' || event.value === 'PaymentTerm' || event.value === 'PayPal') {
      this.partialPaymentType = 'full';
    }
    if (this.data["cc_payment_api"] == "squareup" && event.value === 'Card') {
      this.getApiInfoSettings();
    }
    else {
      this.unloadScript();
    }

    this.recaptchaResult = '';
    if (this.data["cc_payment_api"] == "quickbooks" && event.value === 'Card') {
      this.renderReCaptcha();
    }

    this.ValidationForm();
    this.validateProjectData();
  }

  openAddressDialog(type): void {
    this.checkOutForm.controls.payment_mode.setValue('');
    let u_id = localStorage.getItem("quote_user_id");
    const dialogRef = this.dialog.open(ClientAddressEditComponent, {
      width: "800px",
      disableClose: true,
      data: {
        name: "Admin",
        message: "Client",
        manageData: { client_id: u_id, type: type }
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "success") {
        this.getCards();
      }
      else if (result == "showAddress") {
        // this.showAddress = true;
      }
      else {
      }
    });
  }

  showThankyou() {
    this.timer();
    this.paymentSuccess = true;
    setTimeout(() => {
      this.paymentSuccess = false;
      this.dialogRef.close("success");
    }, 5000);
  }

  notificationMessage(message) {
    this._flashMessagesService.show(message, {
      cssClass: "alert-warning",
      timeout: 5000
    });
    window.scrollTo(0, 0);
  }

  timer() {
    let minute = .5;
    let seconds: number = 5;
    let textSec: any = "0";
    let statSec: number = 5;

    const prefix = minute < 10 ? "0" : "";

    const timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      this.display = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

      if (seconds == 0) {
        clearInterval(timer);
      }
    }, 1000);
  }

  ResetPopupData() {
    this.address_id = "";
    this.shipAddress = null;
    this.checkOutForm.get('address').setValue(this.address_id);
  }

  ValidationForm() {
    const skipTurnaroundValidation = this.data.scheduledDate;
    if (
      this.checkOutForm.value.payment_mode != "" &&
      this.deliveryMethod != 'select' &&
      (skipTurnaroundValidation || (this.data.turn_around_time != "" && this.data.projects.turn_around_time_key != "")) &&
      (this.shippingAddressId != "" || this.address_id != "") &&
      this.data.shipping_method != ""
    ) {
      this.isFormValid = false;
    }
    else if (this.checkOutForm.value.payment_mode != "" &&
      this.deliveryMethod != 'select' &&
      (skipTurnaroundValidation || (this.data.turn_around_time != "" && this.data.projects.turn_around_time_key != "")) &&
      this.shippingAddressId == "" &&
      this.data.shipping_method == "local_pickup") {
      this.isFormValid = false;
    }
    else {
      this.isFormValid = true;
    }
  }

  //#region SquareUp Payment Gateway

  loadScript() {
    this.loadSquareScript().then(() => {
      this.initializeSquare();
    });
  }

  unloadScript() {
    if (this.myScriptElement) {
      const elements: NodeListOf<Element> = document.querySelectorAll('.sq-card-wrapper');
      const elementArray: Element[] = Array.from(elements);
      elementArray.forEach(element => element.remove());
    }
  }

  loadSquareScript(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.myScriptElement = document.createElement('script');
      this.myScriptElement.src = environment.SQUAREUP_URL;
      this.myScriptElement.onload = () => resolve(); // Resolve the Promise when the script is loaded successfully
      this.myScriptElement.onerror = reject; // Reject the Promise if the script fails to load
      document.body.appendChild(this.myScriptElement);
    });
  }

  async initializeSquare(): Promise<void> {
    if (!window.Square) {
      throw new Error('Square.js failed to load properly');
    }
    try {
      this.payments = window.Square.payments(this.appId, this.locationId);
    } catch (ex) {
      this._flashMessagesService.show(ex, {
        cssClass: "alert-danger",
        timeout: 5000
      });
      return;
    }

    this.card = await this.initializeCard(this.payments);
  }

  async handlePaymentMethodSubmission(amount, redirect_url): Promise<void> {
    try {
      this.loading = true;
      const token = await this.tokenize(this.card);
      this.createPayment(token, amount, redirect_url);
    } catch (e) {
      this.loading = false
      console.error(e.message);
      this._flashMessagesService.show(e.message, {
        cssClass: "alert-danger",
        timeout: 5000
      });
    }
  }

  async initializeCard(payments: any) {
    const card = await payments.card();
    await card.attach('#card-container');
    return card;
  }

  createPayment(token: any, amount, redirect_url) {
    this.loading = true;
    const payload = {
      order_id: this.data.order_id,
      paymentData: {
        idempotencyKey: this.generateUUID(),
        sourceId: token,
        amount: amount,
      }
    }
    this.CommonService.SquareUpPayment(payload).subscribe((response: any) => {
      if (response.status === true) {
        const paymentId = response.data.payment.id;
        this.squareProcessPayments(amount, paymentId, redirect_url);
      } else {
        this.loading = false;
          this._flashMessagesService.show("Payment did't process, please contact administration", {
            cssClass: "alert-warning",
            timeout: 5000
        });
      }
    },
      err => {
        this.loading = false;
        console.log("Error:- ", err);
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-danger",
          timeout: 5000
        });
        window.scrollTo(0, 0);
      }
    );
  }


  squareProcessPayments = function (amount, transactionId, redirectUrl) {
    const paymentData = new FormData();
    paymentData.append('id', this.id);
    paymentData.append('order_id', this.data.order_id);
    paymentData.append('transaction_id', transactionId);
    paymentData.append('payment_type', "Squareup");
    paymentData.append('amount', amount);
    paymentData.append('cardProcessingFee', this.cardProcessingFee);

    this.CommonService.apiService(
      "POST",
      "payment",
      paymentData
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.loading = false;
          if (this.data.isConnectQBO) {
            this.syncInvoicePayment(this.data.order_id, amount, 'Squareup');
          }

          if (this.data.is_public_url === "Yes") {
            this.showThankyou();
          }
          else{
            localStorage.setItem('squarePaymentData', 'true');
            this.dialogRef.close("success");
          }
        } else {
          this.loading = false;
          this._flashMessagesService.show("Payment did't process, please contact administration", {
            cssClass: "alert-warning",
            timeout: 5000
          });
        }
        window.scrollTo(0, 0);
      },
      err => {
        this.loading = false;
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-warning",
          timeout: 5000
        });
      }
    );
  };

  async tokenize(paymentMethod: any) {
    const tokenResult = await paymentMethod.tokenize();
    if (tokenResult.status === 'OK') {
      return tokenResult.token;
    } else {
      let errorMessage = `Tokenization failed with status: ${tokenResult.status}`;
      if (tokenResult.errors) {
        errorMessage += ` and errors: ${JSON.stringify(tokenResult.errors)}`;
      }
      this._flashMessagesService.show(errorMessage, {
        cssClass: "alert-danger",
        timeout: 5000
      });
      throw new Error(errorMessage);
    }
  }

  generateUUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  getApiInfoSettings = function () {
    this.loading = true;
    this.auth0Service.getOAuth2SquareupKeys(this.id).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          let squareupData = response.data;
          this.locationId = squareupData.location_id;
          this.appId = squareupData.app_id;
          this.loadScript();
        } else {
          this._flashMessagesService.show(response.message, {
            cssClass: "alert-warning",
            timeout: 5000
          });
        }
      },
      err => {
        this.loading = false;
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-warning",
          timeout: 5000
        });
        console.log(err.error);
      }
    );
  };

  syncInvoicePayment = function (invoice_id, amount, paymentMethod) {
    this.options = {
      id: this.id,
      invoice_id: invoice_id,
      amount: Number(amount),
      paymentMethod: paymentMethod 
    };
    this.CommonService.apiService(
      "POST",
      "qbo/syncInvoicePayment",
      this.options
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this._flashMessagesService.show(response.message, {
            cssClass: "alert-success",
            timeout: 5000
          });
        }
      },
      err => {
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-danger",
          timeout: 5000
        });
      }
    );
  };

  renderReCaptcha() {
    grecaptcha.ready(() => {
      this.captchaWidgetId = grecaptcha.render('recaptcha-container', {
        'sitekey': environment.recaptcha.siteKey,
        'callback': this.onCaptchaResolved.bind(this),
        'expired-callback': this.onCaptchaExpired.bind(this) 
      });
    });
  }

  onCaptchaResolved(response: string) {
    this.recaptchaResult = response;
  }

  onCaptchaExpired() {
    this.recaptchaResult = '';
  }

  resetReCaptcha() {
    this.recaptchaResult = '';
    if (this.captchaWidgetId !== null) {
      grecaptcha.reset(this.captchaWidgetId);
    }
  }

}




// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/check-out/check-out.component.ts